import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IColourPalette } from "../interfaces/icolourpalette";
import { ColourPaletteService } from "../services/colourpalette.service";
import { Observable } from "rxjs";

@Injectable()
export class ColourPalettesResolver implements Resolve<IColourPalette[]> {

    constructor(private colourPaletteService: ColourPaletteService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IColourPalette[]> {
        return this.colourPaletteService.getAll();
    }
}
